module.exports = __webpack_public_path__ + "img/prize-cat.c65079d6.png";